import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';
import { environment } from 'src/environments/environment';
import { IMaster, IMasterLanguage, IOperationType } from '../models/master.models';
import { OPERATION_TYPE } from 'src/app/user-identification/models/user-identification';

@Injectable({
	providedIn: 'root',
})
export class MasterService extends ApiService {
	private $master: BehaviorSubject<IMaster> = new BehaviorSubject<IMaster>(null);
	private readonly fallbackLanguages: IMasterLanguage[] = [
		{ uuid: 'fallback-es', name: 'es' },
		{ uuid: 'fallback-en', name: 'en' },
	];

	constructor() {
		super();
	}

	public getMaster(): Observable<IMaster> {
		return this.$master.asObservable();
	}

	public setMaster(value: IMaster): void {
		this.$master.next({ ...this.$master.value, ...value });
	}

	public getMasterFromService(): Observable<IMaster> {
		return this.http.get<IMaster>(environment.identity2 + `/master`, {
			headers: this.getHeaders(),
		});
	}

	public getOperationTypes(): IOperationType[] {
		return this.$master.value?.operation_types ?? [];
	}

	public getLanguages(): Array<{ code: string; labelKey: string }> {
		return this.getLanguagesRaw().map((lang) => ({
			code: lang.name,
			labelKey: `GENERAL.LANGUAGE_MISMATCH.LANGUAGES.${lang.name.toUpperCase()}`,
		}));
	}

	public getLanguagesRaw(): IMasterLanguage[] {
		return this.$master.value?.languages?.length ? this.$master.value.languages : this.fallbackLanguages;
	}

	public isAllowedLanguageCode(code: string): boolean {
		return this.getLanguagesRaw().some((lang) => lang.name === code);
	}

	public getUuidOperationType(type: OPERATION_TYPE): string | undefined {
		return this.getOperationTypes().find((ot: IOperationType) => ot.name === type)?.uuid;
	}
}
